import { useCallback } from 'react';
import { isEnterEvent } from '../../../Utils/events.js';
import { focusNextActiveElement } from '../../../../utils/document.js';
import { FieldFlowMode } from '../common.js';
import useFormFlowMode from '../../Field/hooks/useFormFlowMode.js';

function useFieldFlow(fieldFlowMode, onKeyDown) {
    const flowMode = useFormFlowMode(fieldFlowMode);
    const handleKeyPress = useCallback((event) => {
        if (isEnterEvent(event) && flowMode === FieldFlowMode.GO_TO_NEXT_ON_ENTER) {
            setTimeout(focusNextActiveElement, 0);
        }
        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);
    }, [flowMode, onKeyDown]);
    return handleKeyPress;
}

export { useFieldFlow as default };
